import React from 'react';

const Footer = () => {

    return (
		<div className="footer">
			<div className="copyright">
				<p>Copyright © Designed &amp; Developed by <a href="#" target="_blank" rel="noopener noreferrer">Royal Farms & Countryside Resort.</a> 2021</p>
			</div>
		</div>
        )
}
export default Footer